<mat-dialog-content class="logout-box">
  <h5>{{ title | translate }}</h5>
  <p>
    {{ message | translate: {'param': param} }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="center" class="logout-box">
  <button class="site-button site-button-gray m-2" mat-dialog-close tabindex="-1">{{ cancelButtonText | translate }}</button>
  <button (click)="onConfirmClick()" class="site-button m-2" tabindex="1">{{ confirmButtonText | translate }}</button>
</mat-dialog-actions>
